// extracted by mini-css-extract-plugin
export default {"heading":"UsertypesSect_heading__bYAa3","checkmarkBoxContainer":"UsertypesSect_checkmarkBoxContainer__mMIE+"};